import React from "react";

type TabContentProps = {
  tabId: string;
  activeTab: string;
  children: React.ReactNode;
};

const TabContent: React.FC<TabContentProps> = ({
  tabId,
  activeTab,
  children,
}) => {
  return (
    <div
      className={`tab-pane fade ${activeTab === tabId ? "show active" : ""}`}
      id={`v-pills-${tabId}`}
      role="tabpanel"
      aria-labelledby={`v-pills-${tabId}-tab`}
      tabIndex={0}
    >
      {children}
    </div>
  );
};

export default TabContent;
